import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Backdrop, Button, CircularProgress, Divider } from '@material-ui/core';

import { StyledLoginContainer } from '../../login/JiraLogin.styled';
import { useJiraServerAuthUrl, useJiraServerLogin } from './jira-server.hooks';
import { FetchError } from '../../common/api/api';
import { useJiraServerContext } from './jira-server.context';

type BaseJiraServerLoginProps = {
  onError: (error: FetchError) => void;
};
type JiraServerLoginProps = RouteComponentProps & BaseJiraServerLoginProps;

const JiraServerLogin: React.FC<JiraServerLoginProps> = ({
  location,
  onError
}) => {
  const { isJiraServer } = useJiraServerContext();

  const [{ data, error }, get] = useJiraServerAuthUrl();
  const [{ data: user }, jiraLogin] = useJiraServerLogin();

  useEffect(() => {
    console.debug('data', data);
    if (data?.url)
      window.open(
        data.url,
        '_blank',
        'location=yes,height=480,width=640,scrollbars=no,status=no'
      );
  }, [data]);

  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
  }, [error, onError]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('oauth_verifier');
    console.log('code', code);
    if (code) {
      jiraLogin(code);
    }
  }, [jiraLogin, location.search]);

  useEffect(() => {
    // user was already logged in
    if (user && window.opener) {
      // reload the window that opened the authorization popup window
      window.opener.location.reload();
      // close this popup window
      window.close();
    }
  }, [user]);

  return isJiraServer ? (
    <StyledLoginContainer>
      <Divider variant='middle' data-content='OR' />
      <Button
        variant='contained'
        disableElevation
        type='submit'
        color='primary'
        onClick={() => {
          get();
        }}
      >
        Log In with JIRA
      </Button>

      <Backdrop className='backdrop' open={false}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </StyledLoginContainer>
  ) : (
    <></>
  );
};

export default JiraServerLogin;
